(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/caretech/caretech-restrictions/assets/javascripts/caretch-restrictions.js') >= 0) return;  svs.modules.push('/components/caretech/caretech-restrictions/assets/javascripts/caretch-restrictions.js');
'use strict';

var _svs$caretech$caretec;
svs.caretech = svs.caretech || {};
svs.caretech.caretech_restrictions = svs.caretech.caretech_restrictions || {};
const logger = svs.core.log.getLogger('components:caretech-restrictions');
const restrictions = (_svs$caretech$caretec = svs.caretech.caretech_restrictions) === null || _svs$caretech$caretec === void 0 ? void 0 : _svs$caretech$caretec.data;
const careTechReasonTypesEnum = {
  DIALOG: 'Dialog',
  MESSAGE: 'Message'
};
const careTechRestrictionTypesEnum = {
  HIT_TIME_LIMIT: 'hit_time_limit',
  LONG_SESSION: 'Long_session'
};
function displayActiveRestrictionDialog(limitData) {
  svs.caretech.caretech_restrictions.activeRestriction(limitData);
}
function displayCaretechCheck(restrictionDetails) {
  const checkData = {
    id: restrictionDetails.dialogProperties.dialogType,
    mandatory: restrictionDetails.dialogProperties.mandatory === true ? 'true' : 'false',
    interaction_id: restrictionDetails.interactionId
  };
  svs.caretech.caretech_checks.show(checkData);
}
function testGetCaretechRestriction(restrictionId) {
  switch (restrictionId) {
    case String("test".concat(careTechRestrictionTypesEnum.HIT_TIME_LIMIT)):
      return {
        type: careTechRestrictionTypesEnum.HIT_TIME_LIMIT,
        data: '08:15'
      };
    case String("test".concat(careTechRestrictionTypesEnum.LONG_SESSION)):
      return {
        type: careTechRestrictionTypesEnum.LONG_SESSION,
        data: {
          id: 'LongSession',
          mandatory: 'true'
        }
      };
    default:
      return null;
  }
}
async function fetchRestriction(vertical) {
  try {
    const _await$svs$core$jupit = await svs.core.jupiter.callAsync({
        method: 'GET',
        path: "/caretech/1/customer/active-restriction?vertical=".concat(vertical)
      }),
      response = _await$svs$core$jupit.response;
    if (response) {
      return response.response;
    }
  } catch (error) {
    logger.warn('Failed to fetch active restriction', error);
    return error;
  }
  return null;
}
async function getCaretechRestriction(vertical) {
  const restrictionDetails = await fetchRestriction(vertical);
  if (restrictionDetails) {
    switch (restrictionDetails.careTechReason) {
      case careTechReasonTypesEnum.DIALOG:
        logger.info('Got from caretech-restrictions dialog');
        displayCaretechCheck(restrictionDetails);
        return true;
      case careTechReasonTypesEnum.MESSAGE:
        logger.info('Got from caretech-restrictions message');
        displayActiveRestrictionDialog(restrictionDetails);
        return true;
      default:
        break;
    }
    return false;
  }
  return false;
}
function HasCareTechRestriction(vertical) {
  const isPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  if (!isPlayer) {
    return false;
  }
  let hasRestriction = false;
  if (vertical) {
    hasRestriction = getCaretechRestriction(vertical);
  }
  return hasRestriction;
}
svs.caretech.caretech_restrictions = {
  test: {
    testGetCaretechRestriction
  },
  HasCareTechRestriction
};

 })(window);